import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { OpportunityActivitiesComponent } from './opportunity-activities.component';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { GalaxyInfiniteScrollTriggerModule } from '@vendasta/galaxy/infinite-scroll-trigger';
import { CrmActivityLoggerComponent, CrmTimelineComponent } from '@galaxy/crm/static';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    MatButtonModule,
    MatIconModule,
    CrmActivityLoggerComponent,
    CrmTimelineComponent,
    GalaxyInfiniteScrollTriggerModule,
  ],
  declarations: [OpportunityActivitiesComponent],
  exports: [OpportunityActivitiesComponent],
})
export class OpportunityActivitiesModule {}
